export default __webpack_public_path__ + "static/media/themeImg.8e2cfac7.png";